import { render, staticRenderFns } from "./amazonOrder.vue?vue&type=template&id=5c5853c5&scoped=true"
import script from "./amazonOrder.vue?vue&type=script&lang=js"
export * from "./amazonOrder.vue?vue&type=script&lang=js"
import style0 from "./amazonOrder.vue?vue&type=style&index=0&id=5c5853c5&prod&scoped=true&lang=less"
import style1 from "./amazonOrder.vue?vue&type=style&index=1&id=5c5853c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5853c5",
  null
  
)

export default component.exports